import React, { useState } from 'react';
import {
  LineShareButton,
  LineIcon,
} from 'react-share';
import {  FiCopy } from 'react-icons/fi';
import { MdIosShare } from "react-icons/md";
import s from './ShareMenu.module.scss';

type ShareMenuProps = {
  title: string;
  url: string;
};

const ShareMenu: React.FC<ShareMenuProps> = ({ title}) => {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const url = typeof window !== 'undefined' ? window.location.href : '';

  const toggleMenu = () => {
    setOpen(!open);
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error('コピーに失敗しました', err);
    }
  };

  return (
    <div className={s.root}>
      <button onClick={toggleMenu} className={s.shareButton}>
        <MdIosShare size={24} />
        <span>シェア</span>
      </button>

      {open && (
        <div className={s.shareDropdown}>
          <LineShareButton url={url} title={title}>
            <LineIcon size={32} round />
          </LineShareButton>
          <button className={s.copyButton} onClick={copyToClipboard}>
            <FiCopy size={28} />
            <span>{copied ? 'コピー済み' : 'URLコピー'}</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default ShareMenu;
